export default __webpack_public_path__ + "static/media/logooriginal.e0b32ea6.svg";